import React, { useState, useEffect, useContext } from "react";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers-pro/AdapterDayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import dayjs from "dayjs";
import Button from "react-bootstrap/Button";
import { MyContext } from "../../MyContextApi";
import { renderTimeViewClock } from "@mui/x-date-pickers";

function BasicDateTimeRangePicker({
  onFromDateTimeChange,
  onToDateTimeChange,
  clearDates,
}) {
  const { toDateTime, setToDateTime, fromDateTime, setFromDateTime } =
    useContext(MyContext);

  const handleFromDateTime = (newDateTime) => {
    const formattedFromDateTime = dayjs(newDateTime).format(
      "DD-MM-YYYY HH:mm:ss"
    );
    setFromDateTime(newDateTime);
    onFromDateTimeChange(newDateTime);
  };

  const handleToDateTime = (newDateTime) => {
    const formattedToDateTime = dayjs(newDateTime).format(
      "DD-MM-YYYY HH:mm:ss"
    );
    setToDateTime(newDateTime);
    onToDateTimeChange(newDateTime);
  };

  useEffect(() => {
    if (clearDates) {
      setFromDateTime(null);
      setToDateTime(null);
      onFromDateTimeChange(null);
      onToDateTimeChange(null);
    }
  }, [clearDates]);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <div
        style={{
          display: "flex",
          gap: "0px", // Adds space between the two pickers
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <DemoContainer components={["DateTimePicker"]}>
          <DateTimePicker
            label="From"
            value={fromDateTime}
            onChange={handleFromDateTime}
            format="DD-MM-YYYY HH:mm:ss"
            maxDateTime={dayjs()}
            closeOnSelect={false} // Prevents auto-close
            sx={{
              width: "auto !important",
              // minWidth: "150px !important",
              // maxWidth: "250px !important",
              "& .MuiInputBase-root": {
                height: "43px !important",
                overflow: "hidden !important",
                backgroundColor: "#ffffff !important",
                borderRadius: "8px !important",
                padding: "0 10px !important",
                boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1) !important",
              },
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "#d1d1d1 !important",
              },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: "#1976d2 !important",
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "#1976d2 !important",
              },
            }}
            slotProps={{
              actionBar: {
                actions: ["accept", "cancel"], // Shows OK and Cancel buttons
              },
            }}
          />
        </DemoContainer>

        <DemoContainer components={["DateTimePicker"]}>
          <DateTimePicker
            label="To"
            value={toDateTime}
            onChange={handleToDateTime}
            format="DD-MM-YYYY HH:mm:ss"
            maxDateTime={dayjs()}
            closeOnSelect={false} // Prevents auto-close
            sx={{
              width: "auto !important",
              // minWidth: "150px !important",
              // maxWidth: "250px !important",
              "& .MuiInputBase-root": {
                height: "43px !important",
                overflow: "hidden !important",
                backgroundColor: "#ffffff !important",
                borderRadius: "8px !important",
                padding: "0 10px !important",
                boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1) !important",
              },
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "#d1d1d1 !important",
              },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: "#1976d2 !important",
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "#1976d2 !important",
              },
            }}
            slotProps={{
              actionBar: {
                actions: ["accept", "cancel"], // Shows OK and Cancel buttons
              },
            }}
          />
        </DemoContainer>
      </div>
    </LocalizationProvider>
  );
}

export default BasicDateTimeRangePicker;
